/** @fileoverview Barrel for the student deliverable submission drawer. */

export { StudentDeliverableDrawer } from './StudentDeliverableDrawer'
